import { Card, CardContent } from "@/components/ui/card";
import { Building, User } from "lucide-react";

type Person = {
  id: string;
  first_name: string;
  last_name: string;
  email: string | null;
  phone: string | null;
  position: string | null;
  status: string | null;
  tags: string[] | null;
  is_decision_maker: boolean | null;
  notes: string | null;
  linkedin_url: string | null;
  current_client_id: string | null;
  avatar_url?: string | null;
  created_at: string;
  updated_at: string;
  clients?: {
    name: string;
  };
};

interface PersonCardProps {
  person: Person;
  isSelected: boolean;
  onClick: () => void;
  getLastActivity: (personId: string) => string;
}

export function PersonCard({ person, isSelected, onClick }: PersonCardProps) {
  return (
    <Card
      className={`cursor-pointer transition-all ${
        isSelected ? "ring-2 ring-primary bg-accent" : "hover:shadow-md"
      }`}
      onClick={onClick}
    >
      <CardContent className="p-4">
        <div className="flex items-center space-x-3">
          {/* Round Avatar */}
          <div className="w-10 h-10 rounded-full bg-muted flex items-center justify-center flex-shrink-0">
            {person.avatar_url ? (
              <img 
                src={person.avatar_url} 
                alt={`${person.first_name} ${person.last_name}`}
                className="w-full h-full object-cover rounded-full"
              />
            ) : (
              <User className="h-5 w-5 text-muted-foreground" />
            )}
          </div>
          
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-sm truncate">
              {person.first_name} {person.last_name}
            </h3>
            
            <div className="flex items-center text-xs text-muted-foreground">
              <Building className="h-3 w-3 mr-1 flex-shrink-0" />
              <span className="truncate">{person.clients?.name || "No company"}</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}